<template>
  <div>
    <v-card shaped outlined>
      <v-alert dark :color="color"><slot></slot></v-alert>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#1B5E20",
    },
  },
};
</script>

<style></style>
